export default {
  count: 19,
  next: null,
  previous: null,
  results: [
    {
      id: 4,
      name: "Action",
      slug: "action",
      games_count: 179051,
      image_background:
        "https://media.rawg.io/media/games/b8c/b8c243eaa0fbac8115e0cdccac3f91dc.jpg",
      games: [
        {
          id: 3498,
          slug: "grand-theft-auto-v",
          name: "Grand Theft Auto V",
          added: 19107,
        },
        {
          id: 3328,
          slug: "the-witcher-3-wild-hunt",
          name: "The Witcher 3: Wild Hunt",
          added: 18264,
        },
        {
          id: 5286,
          slug: "tomb-raider",
          name: "Tomb Raider (2013)",
          added: 15070,
        },
        {
          id: 4291,
          slug: "counter-strike-global-offensive",
          name: "Counter-Strike: Global Offensive",
          added: 14884,
        },
        {
          id: 12020,
          slug: "left-4-dead-2",
          name: "Left 4 Dead 2",
          added: 14585,
        },
        {
          id: 5679,
          slug: "the-elder-scrolls-v-skyrim",
          name: "The Elder Scrolls V: Skyrim",
          added: 14481,
        },
      ],
    },
    {
      id: 3,
      name: "Adventure",
      slug: "adventure",
      games_count: 137837,
      image_background:
        "https://media.rawg.io/media/games/b7d/b7d3f1715fa8381a4e780173a197a615.jpg",
      games: [
        {
          id: 3498,
          slug: "grand-theft-auto-v",
          name: "Grand Theft Auto V",
          added: 19107,
        },
        {
          id: 3328,
          slug: "the-witcher-3-wild-hunt",
          name: "The Witcher 3: Wild Hunt",
          added: 18264,
        },
        {
          id: 5286,
          slug: "tomb-raider",
          name: "Tomb Raider (2013)",
          added: 15070,
        },
        { id: 13536, slug: "portal", name: "Portal", added: 14617 },
        {
          id: 28,
          slug: "red-dead-redemption-2",
          name: "Red Dead Redemption 2",
          added: 13838,
        },
        {
          id: 3439,
          slug: "life-is-strange-episode-1-2",
          name: "Life is Strange",
          added: 13815,
        },
      ],
    },
    {
      id: 11,
      name: "Arcade",
      slug: "arcade",
      games_count: 22544,
      image_background:
        "https://media.rawg.io/media/games/363/36306deef81e7955a5d0f5c3b43fccee.jpg",
      games: [
        { id: 3612, slug: "hotline-miami", name: "Hotline Miami", added: 9420 },
        {
          id: 17540,
          slug: "injustice-gods-among-us-ultimate-edition",
          name: "Injustice: Gods Among Us Ultimate Edition",
          added: 8629,
        },
        { id: 22509, slug: "minecraft", name: "Minecraft", added: 7409 },
        { id: 4003, slug: "grid-2", name: "GRID 2", added: 6806 },
        {
          id: 3408,
          slug: "hotline-miami-2-wrong-number",
          name: "Hotline Miami 2: Wrong Number",
          added: 5504,
        },
        {
          id: 16343,
          slug: "a-story-about-my-uncle",
          name: "A Story About My Uncle",
          added: 5404,
        },
      ],
    },
    {
      id: 28,
      name: "Board Games",
      slug: "board-games",
      games_count: 8284,
      image_background:
        "https://media.rawg.io/media/screenshots/f64/f6470e82e699c6f4d6e151ecaf13e256.jpg",
      games: [
        {
          id: 23557,
          slug: "gwent-the-witcher-card-game",
          name: "Gwent: The Witcher Card Game",
          added: 4252,
        },
        {
          id: 327999,
          slug: "dota-underlords",
          name: "Dota Underlords",
          added: 3589,
        },
        {
          id: 2055,
          slug: "adventure-capitalist",
          name: "AdVenture Capitalist",
          added: 2997,
        },
        { id: 2306, slug: "poker-night-2", name: "Poker Night 2", added: 1921 },
        { id: 3187, slug: "armello", name: "Armello", added: 1814 },
        { id: 758, slug: "hue", name: "Hue", added: 1755 },
      ],
    },
    {
      id: 17,
      name: "Card",
      slug: "card",
      games_count: 4474,
      image_background:
        "https://media.rawg.io/media/screenshots/8ff/8ffe8f19d2e764867c8ed625ddf4e368.jpg",
      games: [
        {
          id: 23557,
          slug: "gwent-the-witcher-card-game",
          name: "Gwent: The Witcher Card Game",
          added: 4252,
        },
        {
          id: 28121,
          slug: "slay-the-spire",
          name: "Slay the Spire",
          added: 4228,
        },
        {
          id: 18852,
          slug: "poker-night-at-the-inventory",
          name: "Poker Night at the Inventory",
          added: 2549,
        },
        { id: 8923, slug: "faeria", name: "Faeria", added: 2011 },
        {
          id: 332,
          slug: "the-elder-scrolls-legends",
          name: "The Elder Scrolls: Legends",
          added: 1946,
        },
        { id: 2306, slug: "poker-night-2", name: "Poker Night 2", added: 1921 },
      ],
    },
    {
      id: 40,
      name: "Casual",
      slug: "casual",
      games_count: 43757,
      image_background:
        "https://media.rawg.io/media/screenshots/054/054bf49d9e736edfda5aa8e9015faf9b.jpeg",
      games: [
        { id: 9721, slug: "garrys-mod", name: "Garry's Mod", added: 8614 },
        {
          id: 326292,
          slug: "fall-guys",
          name: "Fall Guys: Ultimate Knockout",
          added: 7606,
        },
        { id: 9830, slug: "brawlhalla", name: "Brawlhalla", added: 6529 },
        { id: 356714, slug: "among-us", name: "Among Us", added: 6204 },
        {
          id: 1959,
          slug: "goat-simulator",
          name: "Goat Simulator",
          added: 5735,
        },
        {
          id: 16343,
          slug: "a-story-about-my-uncle",
          name: "A Story About My Uncle",
          added: 5404,
        },
      ],
    },
    {
      id: 34,
      name: "Educational",
      slug: "educational",
      games_count: 16381,
      image_background:
        "https://media.rawg.io/media/screenshots/9d4/9d45ba1c76712ad692fadda67f2777a9.jpeg",
      games: [
        {
          id: 1358,
          slug: "papers-please",
          name: "Papers, Please",
          added: 6106,
        },
        { id: 1140, slug: "world-of-goo", name: "World of Goo", added: 4059 },
        {
          id: 2778,
          slug: "surgeon-simulator-cpr",
          name: "Surgeon Simulator",
          added: 3567,
        },
        { id: 9768, slug: "gameguru", name: "GameGuru", added: 2278 },
        {
          id: 13777,
          slug: "sid-meiers-civilization-iv-colonization",
          name: "Sid Meier's Civilization IV: Colonization",
          added: 2117,
        },
        {
          id: 6885,
          slug: "pirates-3",
          name: "Sid Meier's Pirates!",
          added: 2016,
        },
      ],
    },
    {
      id: 19,
      name: "Family",
      slug: "family",
      games_count: 5380,
      image_background:
        "https://media.rawg.io/media/games/0c1/0c1c9965ba59166ab986a663ab2252dc.jpg",
      games: [
        { id: 3254, slug: "journey", name: "Journey", added: 7816 },
        {
          id: 2597,
          slug: "lego-lord-of-the-rings",
          name: "LEGO The Lord of the Rings",
          added: 4974,
        },
        { id: 3350, slug: "broken-age", name: "Broken Age", added: 4646 },
        {
          id: 3729,
          slug: "lego-the-hobbit",
          name: "LEGO The Hobbit",
          added: 4573,
        },
        { id: 1259, slug: "machinarium", name: "Machinarium", added: 4120 },
        { id: 1140, slug: "world-of-goo", name: "World of Goo", added: 4059 },
      ],
    },
    {
      id: 6,
      name: "Fighting",
      slug: "fighting",
      games_count: 12465,
      image_background:
        "https://media.rawg.io/media/games/aa3/aa36ba4b486a03ddfaef274fb4f5afd4.jpg",
      games: [
        {
          id: 17540,
          slug: "injustice-gods-among-us-ultimate-edition",
          name: "Injustice: Gods Among Us Ultimate Edition",
          added: 8629,
        },
        {
          id: 108,
          slug: "mortal-kombat-x",
          name: "Mortal Kombat X",
          added: 7958,
        },
        {
          id: 28179,
          slug: "sega-mega-drive-and-genesis-classics",
          name: "SEGA Mega Drive and Genesis Classics",
          added: 7310,
        },
        { id: 9830, slug: "brawlhalla", name: "Brawlhalla", added: 6529 },
        {
          id: 274480,
          slug: "mortal-kombat-11",
          name: "Mortal Kombat 11",
          added: 4720,
        },
        {
          id: 44525,
          slug: "yakuza-kiwami",
          name: "Yakuza Kiwami",
          added: 4065,
        },
      ],
    },
    {
      id: 51,
      name: "Indie",
      slug: "indie",
      games_count: 51548,
      image_background:
        "https://media.rawg.io/media/games/713/713269608dc8f2f40f5a670a14b2de94.jpg",
      games: [
        { id: 1030, slug: "limbo", name: "Limbo", added: 12348 },
        {
          id: 3272,
          slug: "rocket-league",
          name: "Rocket League",
          added: 11250,
        },
        { id: 422, slug: "terraria", name: "Terraria", added: 11056 },
        { id: 9767, slug: "hollow-knight", name: "Hollow Knight", added: 9622 },
        { id: 3612, slug: "hotline-miami", name: "Hotline Miami", added: 9420 },
        { id: 3790, slug: "outlast", name: "Outlast", added: 9353 },
      ],
    },
    {
      id: 59,
      name: "Massively Multiplayer",
      slug: "massively-multiplayer",
      games_count: 3169,
      image_background:
        "https://media.rawg.io/media/games/d0f/d0f91fe1d92332147e5db74e207cfc7a.jpg",
      games: [
        { id: 32, slug: "destiny-2", name: "Destiny 2", added: 12150 },
        { id: 10213, slug: "dota-2", name: "Dota 2", added: 11083 },
        { id: 766, slug: "warframe", name: "Warframe", added: 10942 },
        { id: 290856, slug: "apex-legends", name: "Apex Legends", added: 9697 },
        {
          id: 10533,
          slug: "path-of-exile",
          name: "Path of Exile",
          added: 8742,
        },
        {
          id: 10142,
          slug: "playerunknowns-battlegrounds",
          name: "PlayerUnknown’s Battlegrounds",
          added: 8602,
        },
      ],
    },
    {
      id: 83,
      name: "Platformer",
      slug: "platformer",
      games_count: 106974,
      image_background:
        "https://media.rawg.io/media/games/569/569ea25d2b56bd05c7fa309ddabe81ff.jpg",
      games: [
        { id: 1030, slug: "limbo", name: "Limbo", added: 12348 },
        { id: 422, slug: "terraria", name: "Terraria", added: 11056 },
        { id: 9767, slug: "hollow-knight", name: "Hollow Knight", added: 9622 },
        {
          id: 41,
          slug: "little-nightmares",
          name: "Little Nightmares",
          added: 9509,
        },
        { id: 18080, slug: "half-life", name: "Half-Life", added: 8957 },
        {
          id: 3144,
          slug: "super-meat-boy",
          name: "Super Meat Boy",
          added: 8606,
        },
      ],
    },
    {
      id: 7,
      name: "Puzzle",
      slug: "puzzle",
      games_count: 100740,
      image_background:
        "https://media.rawg.io/media/games/328/3283617cb7d75d67257fc58339188742.jpg",
      games: [
        { id: 4200, slug: "portal-2", name: "Portal 2", added: 17209 },
        { id: 13536, slug: "portal", name: "Portal", added: 14617 },
        { id: 1030, slug: "limbo", name: "Limbo", added: 12348 },
        {
          id: 19709,
          slug: "half-life-2-episode-two",
          name: "Half-Life 2: Episode Two",
          added: 9743,
        },
        { id: 18080, slug: "half-life", name: "Half-Life", added: 8957 },
        { id: 1450, slug: "inside", name: "INSIDE", added: 7164 },
      ],
    },
    {
      id: 1,
      name: "Racing",
      slug: "racing",
      games_count: 24635,
      image_background:
        "https://media.rawg.io/media/games/082/082365507ff04d456c700157072d35db.jpg",
      games: [
        {
          id: 3272,
          slug: "rocket-league",
          name: "Rocket League",
          added: 11250,
        },
        { id: 4003, slug: "grid-2", name: "GRID 2", added: 6806 },
        { id: 2572, slug: "dirt-rally", name: "DiRT Rally", added: 6096 },
        {
          id: 58753,
          slug: "forza-horizon-4",
          name: "Forza Horizon 4",
          added: 5428,
        },
        { id: 5578, slug: "grid", name: "Race Driver: Grid", added: 5001 },
        { id: 4347, slug: "dirt-showdown", name: "DiRT Showdown", added: 4344 },
      ],
    },
    {
      id: 5,
      name: "RPG",
      slug: "role-playing-games-rpg",
      games_count: 54150,
      image_background:
        "https://media.rawg.io/media/games/da1/da1b267764d77221f07a4386b6548e5a.jpg",
      games: [
        {
          id: 3328,
          slug: "the-witcher-3-wild-hunt",
          name: "The Witcher 3: Wild Hunt",
          added: 18264,
        },
        {
          id: 5679,
          slug: "the-elder-scrolls-v-skyrim",
          name: "The Elder Scrolls V: Skyrim",
          added: 14481,
        },
        { id: 802, slug: "borderlands-2", name: "Borderlands 2", added: 13802 },
        {
          id: 58175,
          slug: "god-of-war-2",
          name: "God of War (2018)",
          added: 12155,
        },
        { id: 3070, slug: "fallout-4", name: "Fallout 4", added: 12138 },
        {
          id: 278,
          slug: "horizon-zero-dawn",
          name: "Horizon Zero Dawn",
          added: 11592,
        },
      ],
    },
    {
      id: 2,
      name: "Shooter",
      slug: "shooter",
      games_count: 63421,
      image_background:
        "https://media.rawg.io/media/games/120/1201a40e4364557b124392ee50317b99.jpg",
      games: [
        { id: 4200, slug: "portal-2", name: "Portal 2", added: 17209 },
        {
          id: 4291,
          slug: "counter-strike-global-offensive",
          name: "Counter-Strike: Global Offensive",
          added: 14884,
        },
        {
          id: 12020,
          slug: "left-4-dead-2",
          name: "Left 4 Dead 2",
          added: 14585,
        },
        {
          id: 4062,
          slug: "bioshock-infinite",
          name: "BioShock Infinite",
          added: 13977,
        },
        { id: 802, slug: "borderlands-2", name: "Borderlands 2", added: 13802 },
        { id: 13537, slug: "half-life-2", name: "Half-Life 2", added: 13060 },
      ],
    },
    {
      id: 14,
      name: "Simulation",
      slug: "simulation",
      games_count: 67385,
      image_background:
        "https://media.rawg.io/media/games/179/179245a3693049a11a25b900ab18f8f7.jpg",
      games: [
        { id: 10035, slug: "hitman", name: "Hitman", added: 9698 },
        {
          id: 654,
          slug: "stardew-valley",
          name: "Stardew Valley",
          added: 8708,
        },
        { id: 9721, slug: "garrys-mod", name: "Garry's Mod", added: 8614 },
        {
          id: 10243,
          slug: "company-of-heroes-2",
          name: "Company of Heroes 2",
          added: 8424,
        },
        {
          id: 9882,
          slug: "dont-starve-together",
          name: "Don't Starve Together",
          added: 8058,
        },
        { id: 22509, slug: "minecraft", name: "Minecraft", added: 7409 },
      ],
    },
    {
      id: 15,
      name: "Sports",
      slug: "sports",
      games_count: 20844,
      image_background:
        "https://media.rawg.io/media/games/d16/d160819f22de73d29813f7b6dad815f9.jpg",
      games: [
        {
          id: 3272,
          slug: "rocket-league",
          name: "Rocket League",
          added: 11250,
        },
        {
          id: 326292,
          slug: "fall-guys",
          name: "Fall Guys: Ultimate Knockout",
          added: 7606,
        },
        { id: 2572, slug: "dirt-rally", name: "DiRT Rally", added: 6096 },
        {
          id: 53341,
          slug: "jet-set-radio-2012",
          name: "Jet Set Radio",
          added: 4755,
        },
        { id: 9575, slug: "vrchat", name: "VRChat", added: 3936 },
        {
          id: 622492,
          slug: "forza-horizon-5",
          name: "Forza Horizon 5",
          added: 3923,
        },
      ],
    },
    {
      id: 10,
      name: "Strategy",
      slug: "strategy",
      games_count: 53888,
      image_background:
        "https://media.rawg.io/media/games/a88/a886c37bf112d009e318b106db9d420a.jpg",
      games: [
        {
          id: 13633,
          slug: "civilization-v",
          name: "Sid Meier's Civilization V",
          added: 8539,
        },
        {
          id: 10243,
          slug: "company-of-heroes-2",
          name: "Company of Heroes 2",
          added: 8424,
        },
        {
          id: 13910,
          slug: "xcom-enemy-unknown",
          name: "XCOM: Enemy Unknown",
          added: 7602,
        },
        { id: 5525, slug: "brutal-legend", name: "Brutal Legend", added: 7530 },
        {
          id: 10065,
          slug: "cities-skylines",
          name: "Cities: Skylines",
          added: 7362,
        },
        {
          id: 11147,
          slug: "ark-survival-of-the-fittest",
          name: "ARK: Survival Of The Fittest",
          added: 7037,
        },
      ],
    },
  ],
};
